<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>版本号配置</span>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="版本号" name="first">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(v,i) in formData" :key="i">
                <el-form-item label="版本号">
                  <el-input v-model="formData[i]" style="width: 150px;" placeholder="版本号" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:versionSet:del']" type="danger" @click="del(i,1)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-button v-permisaction="['config:versionSet:add']" type="primary" @click="add()">+</el-button>
              <el-button v-permisaction="['config:versionSet:add']" type="primary" @click="onSubmit(1)">保存</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="资源版本号" name="second">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(v,i) in formData2" :key="i">
                <el-form-item label="版本号">
                  <el-input v-model="formData2[i]" style="width: 150px;" placeholder="版本号" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:versionSet:del']" type="danger" @click="del(i,2)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-button v-permisaction="['config:versionSet:add']" type="primary" @click="add(2)">+</el-button>
              <el-button v-permisaction="['config:versionSet:add']" type="primary" @click="onSubmit(2)">保存</el-button>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getVersionCfg, updateVersionCfg } from '@/api/config/version-set'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'VersionSet',
  data() {
    return {
      total: 0,
      options: [],
      rewardType: [],
      activeName: 'first',
      formData: [],
      formData2: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit(type = 1) {
      if (type === 2) {
        for (const i in this.formData2) {
          const val = this.formData2[i]
          const count = val.split('.').length - 1
          if (count !== 2) {
            this.msgError('大版本有误,示例:1.6.0')
            return
          }
        }
        const data = JSON.stringify(this.formData2)
        this.$confirm('此操作将影响到资源版本, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateCommonCfg({ data: data, name: 'StaticVersion' }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })

        return
      }
      const data = this.formData.join(',')

      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateVersionCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getVersionCfg().then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })

      getCommonCfg({ name: 'StaticVersion' }).then(res => {
        this.formData2 = res.data
      })
    },
    add(type = 1) {
      if (type === 1) {
        this.formData.push(0)
      } else {
        this.formData2.push(0)
      }
    },
    del(index, type = 1) {
      if (type === 1) {
        this.formData = this.formData.filter((item, key) => {
          return key !== index
        })
      } else {
        this.formData2 = this.formData2.filter((item, key) => {
          return key !== index
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
